import React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../types/state/storeTypes';
import { User } from '../../types/api/UsersTypes';
import { UserSurveyModalProps } from '../../types/components/user-survey/UserSurveyModal';

import { Dialog } from '@headlessui/react';
import UserSurveyFlow from '../user-survey/UserSurveyFlow'
import { ExitIcon } from '../../modules/Icons';

const UserSurveyModal: React.FC<UserSurveyModalProps> = ({
  isOpen = false,
  setIsOpen,
  user
}) => {

  const close = () => {
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={close} className="relative z-[99]">
      <div className="fixed inset-0 bg-black/60" />
      <div cy-test-id="user-survey-modal" className="fixed inset-0 overflow-y-auto">
        <div className="flex items-center justify-center min-h-full text-center">
          {/* Animated gradient border wrapper */}
          <div className="relative group rounded-[10px] inline-block p-[1.5px] overflow-hidden">
            <span className="absolute inset-[-1000%] animate-[spin_40s_linear_infinite] bg-[conic-gradient(from_0deg_at_50%_50%,#00A1E0_0%,#1F2937_40%,#00A1E0_60%,#1F2937_80%,#252A2D_90%,#00A1E0_100%)]" />
            <Dialog.Panel className="w-full lg:max-w-[860px] transform overflow-hidden rounded-[9px] lg:px-[48px] pt-[36px] pb-[50px] text-left align-middle shadow-xl transition-all bg-gray-900">
              <UserSurveyFlow user={user} onFlowCompleted={close}/>
              <ExitIcon className="absolute w-6 cursor-pointer top-6 right-6" onClick={close} />
            </Dialog.Panel>
          </div>
        </div>
      </div>
    </Dialog>

  );
};

const mapStateToProps = (state: ApplicationState) => ({
  user: state.auth.user as User,
});

export default connect(mapStateToProps)(UserSurveyModal);
